// import React, { useState } from "react";
// import { Routes, Route, Navigate } from "react-router-dom";

// import SideBar from "./components/Sidebar";
// import Dashboard from "./pages/Dashboard";
// import UserAdd from "./pages/UserAdd";
// import RTIAdd from "./pages/RTIAdd";
// import DeveloperAdd from "./pages/DeveloperChargesAdd";
// import Layout from "./layout/Layout";
// import UserList from "./pages/UserList";
// import RTIList from "./pages/RTIList.jsx";
// import RTIPrint from "./components/RTIPrint";
// import DeveloperChargesList from "./pages/DeveloperChargesList"; 
// import DeveloperChargesPrint from "./components/DeveloperChargesPrint";
// import OccupancyTransferAdd from "./pages/OccupancyTransferAdd";
// import OccupancyTransferList from "./pages/OccupancyTransferList.jsx";
// import OccupancyTransferPrint from "./components/OccupancyTransferPrint.jsx";

// /* ✅ ADD LOGIN PAGE */
// import Login from "./pages/Login";

// function App() {
//   const [isCollapsed, setIsCollapsed] = useState(false);

//   /* ✅ CHECK TOKEN */
//   const token = localStorage.getItem("token");

//  return (
//    <div className="flex min-h-screen">
//     <div className="flex-1 overflow-auto">
//       <Routes>

//           {/* ✅ LOGIN ROUTE */}
//           <Route
//             path="/login"
//             element={
//               token ? <Navigate to="/" /> : <Login />
//             }
//           />

//           {/* Layout as parent */}
//           <Route
//             path="/"
//             element={
//               token ? <Layout /> : <Navigate to="/login" />
//             }
//           >

//             {/* Dashboard inside Outlet */}
//             <Route index element={<Dashboard />} />

//             {/* Other pages */}
//             <Route path="user-add" element={<UserAdd />} />
//             <Route path="user-list" element={<UserList />} />
//             <Route path="rti-add" element={<RTIAdd />} />
//             <Route path="rti-list" element={<RTIList />} />
//             <Route path="developer-add" element={<DeveloperAdd />} />
//             <Route path="rti-print/:id" element={<RTIPrint />} />
//             <Route path="/developer-list" element={<DeveloperChargesList />} />
//             <Route path="/developer-print/:id" element={<DeveloperChargesPrint />} />

//             <Route path="/occupancy-list" element={<OccupancyTransferList />} />
//             <Route path="/occupancy-print/:id" element={<OccupancyTransferPrint />} />
//             <Route path="/occupancy-add" element={<OccupancyTransferAdd />} />

//           </Route>

//         </Routes>
//       </div>

//     </div>
//   );
// }

// export default App;



import React, { useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import Dashboard from "./pages/Dashboard";
import UserAdd from "./pages/UserAdd";
import UserList from "./pages/UserList";

import RTIAdd from "./pages/RTIAdd";
import RTIList from "./pages/RTIList";
import RTIPrint from "./components/RTIPrint";

import DeveloperAdd from "./pages/DeveloperChargesAdd";
import DeveloperChargesList from "./pages/DeveloperChargesList";
import DeveloperChargesPrint from "./components/DeveloperChargesPrint";

import OccupancyTransferAdd from "./pages/OccupancyTransferAdd";
import OccupancyTransferList from "./pages/OccupancyTransferList";
import OccupancyTransferPrint from "./components/OccupancyTransferPrint";

import Layout from "./layout/Layout";
import Login from "./pages/Login";

function App() {
  const [isCollapsed, setIsCollapsed] = useState(false);

  // CHECK TOKEN
  const token = localStorage.getItem("token");

  return (
    <div className="flex min-h-screen">
      <div className="flex-1 overflow-auto">

        <Routes>

          {/* LOGIN */}
          <Route
            path="/login"
            element={
              token ? <Navigate to="/" /> : <Login />
            }
          />

          {/* PROTECTED ROUTES */}
          <Route
            path="/"
            element={
              token ? <Layout /> : <Navigate to="/login" />
            }
          >

            {/* DASHBOARD */}
            <Route index element={<Dashboard />} />

            {/* USERS */}
            <Route path="user-add" element={<UserAdd />} />
            <Route path="user-list" element={<UserList />} />

            {/* RTI */}
            <Route path="rti-add" element={<RTIAdd />} />
            <Route path="rti-edit/:id" element={<RTIAdd />} />
            <Route path="rti-list" element={<RTIList />} />
            <Route path="rti-print/:id" element={<RTIPrint />} />

            {/* DEVELOPER CHARGES */}
            <Route path="developer-add" element={<DeveloperAdd />} />
            <Route
              path="developer-charges/edit/:id"
              element={<DeveloperAdd />}
            />
            <Route
              path="developer-list"
              element={<DeveloperChargesList />}
            />
            <Route
              path="developer-print/:id"
              element={<DeveloperChargesPrint />}
            />

            {/* OCCUPANCY TRANSFER */}
            <Route
              path="occupancy-add"
              element={<OccupancyTransferAdd />}
            />
            <Route
              path="occupancy-transfer-edit/:id"
              element={<OccupancyTransferAdd />}
            />
            <Route
              path="occupancy-list"
              element={<OccupancyTransferList />}
            />
            <Route
              path="occupancy-print/:id"
              element={<OccupancyTransferPrint />}
            />

          </Route>

        </Routes>

      </div>
    </div>
  );
}

export default App;